import React, { Suspense } from 'react';
import { Container, CssBaseline, ThemeProvider } from '@mui/material';
import { muiTheme } from 'utils/mui';
import AuthWrapper from 'utils/authentication/AuthWrapper';
import { Redirect, Route, Switch } from 'wouter';
import MainPage from 'pages/Main';
import Auth0Callback from 'utils/authentication/Auth0Callback';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import Loading from 'components/Loading';
import { SnackbarProvider } from 'notistack';
import './assets/css/font.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'

dayjs.locale('pt-br')

export default function App() {
  const queryClient = new QueryClient();
  return (
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<Loading />}>
        <ThemeProvider theme={muiTheme}>
          <CssBaseline />
          <SnackbarProvider>
            <Container maxWidth={false} sx={{ display: 'flex', height: '100%', flexDirection: 'column' }} disableGutters>
              <AuthWrapper>
                {() => (
                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
                    <Switch>
                      <Route path="/main" component={MainPage} />
                      <Route path="/">
                        <Redirect to='/callback' />
                      </Route>
                      <Route path='/callback' component={Auth0Callback} />
                      {/* <Route component={NotFoundPage} />Should always be the last route entry */}
                    </Switch>
                  </LocalizationProvider>
                )}
              </AuthWrapper>
            </Container>
          </SnackbarProvider>
        </ThemeProvider>
      </Suspense>
    </QueryClientProvider>
  );
}
